import { IApplicationState } from '../../types/redux';

export const selectAllRecommendationsUrl = (state: IApplicationState) => {
  return state.newbuildingRecommendations.allRecommendationsUrl;
};
